import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTAuctionABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { listenEvent } from "src/utils/multicall";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_AUCTION_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, NFT_AUCTION_ADDRESS);
  if (!contractReader) throw new Error("Failed to create nft-manager contract reader");
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, NFT_AUCTION_ADDRESS);
  if (!contractSender) throw new Error("Failed to create nft-manager contract sender");
  return contractSender;
}

async function getTokenOrder(orderID) {
  const res = await getContractReader().methods.getTokenOrder(orderID).call();
  return res;
}

async function getTokenOnAuctionCount() {
  const count = await getContractReader().methods.getTokenOnAunctionCount().call();
  return parseInt(count);
}

async function getRemainingTime(tokenId) {
  const res = await getContractReader().methods.getRemainingTime(tokenId).call();
  return parseInt(res);
}

async function getTokenOfOwnerBalance(owner) {
  const res = await getContractReader().methods.getTokenOfOwnerBalance(owner).call();
  return parseInt(res);
}

async function cancelAuction(dispatch, tokenId, accountAddress, text) {
  const emit = getContractSender().methods.cancelAuction(tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, text);
  await emit;
}

async function editAuctionPrice(dispatch, tokenId, newPrice, accountAddress) {
  const emit = getContractSender().methods.editAuctionPrice(tokenId, newPrice).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Edit auction");
  await emit;
}

async function createAuction(dispatch, tokenId, startingBid, duration, accountAddress, onTxHash = () => {}) {
  const emit = getContractSender()
    .methods.createAuction(tokenId, startingBid, duration, 0, 0)
    .send({ from: accountAddress });
  emit.on("transactionHash", onTxHash);
  handleEmit(dispatch, emit, "Create auction");
  const res = await emit;
  const data = listenEvent(
    "AuctionCreated(uint256,address,uint256,uint256,uint256,uint256,uint256)",
    [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftSeller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startingBid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ceilingPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "auctionMethod",
        type: "uint256",
      },
    ],
    res["logs"]
  );
  if (data) return { status: "success", tokenId: parseInt(data["tokenId"]) };
  else return { status: "fail" };
}

async function finalizeAuction(dispatch, tokenId, accountAddress, text, onTxHash = () => {}) {
  const emit = getContractSender().methods.finalizeAuction(tokenId).send({ from: accountAddress });
  emit.on("transactionHash", onTxHash);
  handleEmit(dispatch, emit, text);
  const res = await emit;
  if (res.events.AuctionCompleted) {
    const event = res.events.AuctionCompleted;
    return { status: "success", tokenId: parseInt(event.returnValues.tokenId) };
  } else throw new Error("Event not found");
}

async function makeBid(dispatch, tokenId, bidPrice, accountAddress, onTxHash = () => {}) {
  const emit = getContractSender().methods.makeBid(tokenId, bidPrice).send({ from: accountAddress });
  emit.on("transactionHash", onTxHash);
  handleEmit(dispatch, emit, "Bid auction");
  const res = await emit;
  if (res.events.AuctionBid) {
    const event = res.events.AuctionBid;
    return { status: "success", tokenId: parseInt(event.returnValues.tokenId) };
  } else throw new Error("Event not found");
}

export default {
  ABI,
  ADDRESS: NFT_AUCTION_ADDRESS,
  getTokenOnAuctionCount,
  cancelAuction,
  createAuction,
  finalizeAuction,
  getRemainingTime,
  getTokenOfOwnerBalance,
  makeBid,
  getTokenOrder,
  editAuctionPrice,
};
